import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, computed } from 'vue'
import { tableIdByPath } from '@/utils'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'

const __default__ = { name: 'TabsTungee' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  cosId: String,
  customerName: String
},
  setup(__props, { expose: __expose }) {

const contactTableRef = ref()
const goodsTableRef = ref()
const formRef = ref()
const loading = ref(false)
const form = ref<any>({ enterpriseScale: '' })
const activeKey = ref('base')

const props = __props

const contactQueryForm = ref({ cosId: props.cosId, customerName: props.customerName })
const goodsQueryForm = ref({ cosId: props.cosId, customerName: props.customerName })

const fetch = () => {
  changeTabs(activeKey.value)
}

const getInfo = () => {
  request
    .post('lbu/api/tungee/customer/detail', { cosId: props.cosId, customerName: props.customerName })
    .then((res) => {
      if (res.data) {
        form.value = res.data
      }
    })
}

const getContactList = (queryForm: object, callBack: (res: any) => void) => {
  request.post('lbu/api/tungee/contact/page', queryForm).then((res) => {
    callBack(res)
  })
}

const getGoodsCategories = (queryForm: object, callBack: (res: any) => void) => {
  request.post('lbu/api/tungee/goodsCategories/page', queryForm).then((res) => {
    callBack(res)
  })
}

const goodsColumns = computed(() => [
  { title: '名称', dataIndex: 'name', width: 150 },
  { title: '数量', dataIndex: 'quantity', width: 150 },
  { title: '占比', dataIndex: 'pct', width: 150 }
])

const contactColumns = computed(() => [
  { title: '联系方式', dataIndex: 'contactInformation', width: 150 },
  { title: '联系人', dataIndex: 'contacts', width: 150 },
  { title: '来源', dataIndex: 'source', width: 150 }
])

onMounted(() => {
  fetch()
})
// 标签页切换
const changeTabs = (tag: string) => {
  if (tag === 'base') {
    getInfo()
  } else if (tag === 'contact') {
    contactTableRef.value?.fetch()
  } else if (tag === 'goodsCategories') {
    goodsTableRef.value?.fetch()
  }
}

__expose({ fetch })


return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    onChange: changeTabs,
    activeKey: activeKey.value,
    "onUpdate:activeKey": _cache[12] || (_cache[12] = ($event: any) => ((activeKey).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, {
        key: "base",
        tab: "基本信息"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            name: "base",
            model: form.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "客户规模" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.enterpriseScale,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.enterpriseScale) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "年产值" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.gdp,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.gdp) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "平均BSR" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.avgBsr,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.avgBsr) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "配送方式" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.delivery,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.delivery) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主营市场" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.mainMarket,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.mainMarket) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "销往地区" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.sellsArea,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.sellsArea) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "网店品牌" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.brand,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.brand) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "网店平台" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.platform,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.platform) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "开店站点",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.site,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.site) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "主营产品",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.mainProducts,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.mainProducts) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "contact",
        tab: "联系人"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            ref_key: "contactTableRef",
            ref: contactTableRef,
            serial: "",
            search: contactQueryForm.value,
            "onUpdate:search": _cache[10] || (_cache[10] = ($event: any) => ((contactQueryForm).value = $event)),
            columns: contactColumns.value,
            tableId: _unref(tableIdByPath)('contacts'),
            onFetch: getContactList
          }, null, 8, ["search", "columns", "tableId"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "goodsCategories",
        tab: "商品类目"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            ref_key: "goodsTableRef",
            ref: goodsTableRef,
            serial: "",
            search: goodsQueryForm.value,
            "onUpdate:search": _cache[11] || (_cache[11] = ($event: any) => ((goodsQueryForm).value = $event)),
            columns: goodsColumns.value,
            tableId: _unref(tableIdByPath)('goodsCategories'),
            onFetch: getGoodsCategories
          }, null, 8, ["search", "columns", "tableId"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["activeKey"]))
}
}

})